import React, { useEffect, useRef, useState } from 'react'
import './home.css'
import Client from './parts/client'
import Story from './parts/story'
import NetworkWrap from './parts/network-effect'
import BannerHome from '@components/banner-home'
import SuperChargedBusiness from '@components/supercharged-business'
import { Helmet } from "react-helmet";
import { API_BASE_URL } from '@utils/constant';


const Home = () => {
	const wasCalled = useRef(false);
	const [isLoadfadeSection, toggleFadeSection] = useState(false);
	const [result, setResult] = useState<any>({})

	async function fetchData() {
		fetch(API_BASE_URL + 'page/home').then(
			function (response) {
				if (response.status !== 200) {
					//console.log('Looks like there was a problem. Status Code: ' +
					//response.status);
					return;
				}
				response.json().then(function (data) {
					setResult(data);
				});
			}
		)
			.catch(function (err) {
				console.log('Fetch Error :-S', err);
			});
	}

	useEffect(() => {
		if (wasCalled.current) return;
		wasCalled.current = true;
		fetchData();
		setTimeout(() => {
			toggleFadeSection(true);

		}, 3000);
	}, []);

	return (
		<>
			{/* <Helmet>
				<title>GoKwik - Boost Conversions. Reduce RTOs. Unlock 10X Growth</title>
				<meta name="description" content="GoKwik is India’s leading eCommerce enablement company committed to building full-stack solutions for eCommerce brands like one-click checkout, RTO management, etc." />
			</Helmet> */}
			<Helmet>
				<title>
					{result?.page?.meta_title ? result?.page?.meta_title : 'GoKwik - Boost Conversions. Reduce RTOs. Unlock 10X Growth'}
				</title>
				<meta name="description" content={`${result?.page?.meta_description ? result?.page?.meta_description : 'GoKwik is India’s leading eCommerce enablement company committed to building full-stack solutions for eCommerce brands like one-click checkout, RTO management, etc.1'}`} />
				{
					result?.page?.meta_keyword &&
					<meta name="keywords" content={result?.page?.meta_keyword}></meta>
				}
			</Helmet>
			<BannerHome animateBanner={true} data={result?.page?.banner}></BannerHome>
			{
				isLoadfadeSection &&
				<>
					<Client group={result?.groups?.block1} blocks={result?.blocks?.block1}></Client>
					<Story data={result} testimonials={result?.page?.testimonials}></Story>
					<NetworkWrap group={result?.groups?.block6} blocks={result?.blocks?.block6}></NetworkWrap>
					<SuperChargedBusiness group={result?.groups?.block8} blocks={result?.blocks?.block8}></SuperChargedBusiness>
				</>
			}

		</>
	)
}
export default Home